import { Component } from '@angular/core';
import { ResolveEnd, Router } from '@angular/router';

import { Stores } from './flux';
import { Services } from './shared/services';
import { AcessoExternoService } from './shared/services/acesso.externo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent
{

    exibirLogout: boolean = false;
    titulo = 'Assinador BNDES - Acesso Externo';


    constructor(private stores: Stores, private router: Router, private acessoExternoService: AcessoExternoService, private svc: Services)
    {
      this.router.events.subscribe((val)=>{
        if(val instanceof ResolveEnd)
        {
          if(val.url && val.url.startsWith('/visualizador'))
          {
            this.exibirLogout = true;
          }
          if(val.url && val.url.startsWith('/acessoExterno'))
          {
            this.exibirLogout = false;
          }
          if(val.url && val.url.startsWith('/sessaoExpirada'))
          {
            this.exibirLogout = false;
          }
        }
      });

      const idAssinatura = this.svc.sessionStorageService.getAssinante();
      const chaveAcesso = this.svc.sessionStorageService.getChaveAcesso();
      const redirecionamentoGovBr = this.svc.sessionStorageService.getRedirecionamentoGovBr();
      const isDadosAssinaturaSessao = chaveAcesso !== null && idAssinatura !== null;

      if(redirecionamentoGovBr && isDadosAssinaturaSessao)
      {
        this.svc.logger.debug('[AppComponent] redirect: /visualizador com code Gov Br');
        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        this.svc.sessionStorageService.removerRedirecionamentoGovBr();

        if(code){
          this.router.navigate(['visualizador', idAssinatura, chaveAcesso, code]);
        }else{
          setTimeout(()=>{this.svc.bnAlertService.alertaErro('Erro', 'Não foi possível registrar assinatura.');}, 1000);
          this.router.navigate(['visualizador', idAssinatura, chaveAcesso]);
        }
      }
    }

    logout()
    {
      document.cookie = 'uri=; Max-Age=-99999999;';
      this.acessoExternoService.realizarLogoutAcessoExterno().then(()=>{
        this.acessoExternoService.realizarLogoutGovBr('sessaoExpirada');
      });
    }
}
